export function playNotificationSound(ctx: AudioContext): void {
  if (ctx.state !== 'running') return

  const notes = [523.25, 659.25] // C5, E5
  notes.forEach((freq, i) => {
    const t = ctx.currentTime + i * 0.2

    const gain = ctx.createGain()
    gain.connect(ctx.destination)
    gain.gain.setValueAtTime(0.4, t)
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.5)

    const osc = ctx.createOscillator()
    osc.connect(gain)
    osc.type = 'sine'
    osc.frequency.setValueAtTime(freq, t)
    osc.start(t)
    osc.stop(t + 0.5)
  })
}
